module.exports = __webpack_public_path__ + "img/toscope-min.063ae8cd.png";